import { getAddress } from '@ethersproject/address'
import memoize from 'lodash/memoize'
import { Token } from '@pancakeswap/sdk'
import chainName from '../config/constants/chainName'

// Logo address overrides: maps a token address to another token's address for logo lookup.
// Used when a token should display the same logo as another existing token.
const LOGO_ADDRESS_OVERRIDES: Record<string, string> = {
  // Q stablecoin → use qUSDT logo
  '0xC3D374365d184bd0A24645778B29A9dfC20Ead01': '0xC276b91c0e8D10260af7b67009d2683bB7776308',
}

const getTokenLogoURL = memoize(
  (token?: Token) => {
    if (token && chainName[token.chainId]) {
      const checksummed = getAddress(token.address)
      const logoAddress = LOGO_ADDRESS_OVERRIDES[checksummed] ?? checksummed
      return `https://raw.githubusercontent.com/RobotMasterxo/qomswapassets/main/${getAddress(logoAddress)}/logo.png`
    }
    return null
  },

  (t) => `${t.chainId}#${t.address}`,
)

export default getTokenLogoURL
